import styled from "styled-components";

export const StyledFooterAlerts = styled.div`
  position: fixed;
  bottom: ${(props) => props.theme.spacing.large};
  right: ${(props) => props.theme.spacing.large};
  display: flex;
  flex-direction: column-reverse;
  gap: ${(props) => props.theme.spacing.normal};
`;

export const StyledAlert = styled.div`
  background-color: ${(props) => props.theme.colors.primary.darkest};
  border-radius: ${(props) => props.theme.radius.normal};
  padding: ${(props) => props.theme.spacing.normal};
  border: 1px solid ${(props) => props.theme.colors.accent.normal};
  color: ${(props) => props.theme.colors.accent.normal};
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.large};
  animation-name: fadeIn;
  animation-duration: 0.5s;
  overflow: hidden;

  @keyframes fadeIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;
